import { render, staticRenderFns } from "./CallTest.vue?vue&type=template&id=cdac915a&scoped=true&"
import script from "./CallTest.vue?vue&type=script&lang=js&"
export * from "./CallTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdac915a",
  null
  
)

export default component.exports